import i18next, { type i18n, type Module } from "i18next";
import { defaultNS, resources } from "./resources";

export { defaultNS, type Namespace, resources } from "./resources";

declare module "i18next" {
	interface CustomTypeOptions {
		defaultNS: typeof defaultNS;
		resources: (typeof resources)["nl"];
	}
}

/**
 * An i18next instance over every namespace, in Dutch. The web app passes `initReactI18next`; a
 * server-side caller (a customer mail) passes nothing and uses `t` directly.
 */
export function createI18n(options: { readonly plugins?: readonly Module[] } = {}): i18n {
	const instance = i18next.createInstance();
	for (const plugin of options.plugins ?? []) instance.use(plugin);
	void instance.init({
		resources,
		lng: "nl",
		fallbackLng: false,
		defaultNS,
		interpolation: { escapeValue: false },
		initAsync: false,
	});
	return instance;
}
